import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/tr';
export const locale = {
  lang: 'tr',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Anketlere danışın',
      'SUBTITULO': 'Belirli bir dönemde platformda oluşturulan anketlerin bilgilerine başvurun',
      'CAMPOS': {
        'anio': 'Yıl',
        'broker': 'Komisyoncu',
        'brokerCountry': 'komisyoncu ülke',
        'anioRanking': 'Yıl sıralaması',
      },
      'RESULTADOS': {
        'CARGANDO': 'Arama sonuçları yükleniyor',
        'TITULO': 'Sonuçlar',
        'ENCONTRADAS': 'Toplam anket bulundu',
        'DESCARGAR': 'Bilgileri Excel formatında indirin',
        'SINRESULTADOS': 'Belirtilen parametrelerle oluşturulmuş anket bulunamadı'
      }
    }
  }
};
